import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["data-t-id"];
import { hocify, hocifyManually } from '@beef/react';
import React from 'react';
import { AutoMetricRoot } from "../AutoMetricRoot";
import { AutoMetricElement } from "../AutoMetricElement";
import { AutoMetricParams } from "../AutoMetricParams";
import { AutoMetricBlockType } from "../../core";
var withAutoMetricRoot = hocify(AutoMetricRoot);
function withAutoMetricParams(mapPropsToParams) {
  return hocifyManually(function (WrappedComponent) {
    return function (props) {
      return /*#__PURE__*/React.createElement(AutoMetricParams, {
        params: mapPropsToParams === null || mapPropsToParams === void 0 ? void 0 : mapPropsToParams(props),
        "data-t-id": "react-hocs"
      }, /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
        "data-t-id": "react-hocs"
      })));
    };
  });
}
function withAutoMetricBlock(type, mapPropsToParams, options) {
  return hocifyManually(function (WrappedComponent) {
    return function (_ref) {
      var _ = _ref['data-t-id'],
        props = _objectWithoutProperties(_ref, _excluded);
      return /*#__PURE__*/React.createElement(AutoMetricElement, _extends({
        params: mapPropsToParams === null || mapPropsToParams === void 0 ? void 0 : mapPropsToParams(props),
        type: type
      }, options), /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
        "data-t-id": "react-hocs"
      })));
    };
  });
}
var canonic = function canonic(mapPropsToParams) {
  return typeof mapPropsToParams === 'string' ? function () {
    return {
      name: mapPropsToParams
    };
  } : mapPropsToParams;
};
/**
 * Shorthand for withAutoMetricBlock
 */
export var withAutoMetric = {
  Root: function Root(api, mapPropsToParams) {
    return withAutoMetricRoot({
      api: api,
      params: canonic(mapPropsToParams)
    });
  },
  Params: function Params(mapPropsToParams) {
    return withAutoMetricParams(mapPropsToParams);
  },
  Section: function Section(mapPropsToParams, options) {
    return withAutoMetricBlock(AutoMetricBlockType.SECTION, canonic(mapPropsToParams), options);
  },
  Container: function Container(mapPropsToParams, options) {
    return withAutoMetricBlock(AutoMetricBlockType.CONTAINER, canonic(mapPropsToParams), options);
  },
  Item: function Item(mapPropsToParams, options) {
    return withAutoMetricBlock(AutoMetricBlockType.ITEM, canonic(mapPropsToParams), options);
  },
  Element: function Element(mapPropsToParams) {
    return withAutoMetricBlock(AutoMetricBlockType.ELEMENT, canonic(mapPropsToParams));
  }
};